import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';

const HeaderButton = ({ handleDownload, status }) => {

  const downloadCSV = () => {
    handleDownload(handleDownload);
  }

  return (
    <div className="header-download-btn-wrapper">
      <Button 
        type="primary" 
        onClick={downloadCSV}
        loading={status === 'PENDING'}
        className="report-download-btn"
      >
        {status !== 'PENDING' && <Icon type="download" />} {status === 'PENDING' ? 'Generating...' : 'Generate CSV'}
      </Button>
    </div>
  );
};

HeaderButton.propTypes = {
  handleDownload: PropTypes.object,
  status: PropTypes.string,
};

export default HeaderButton;
